import {
	ArrowRightIcon,
	Badge,
	ContextBarItem,
	DROP_MENU_SELECTION_MODE,
	DropMenu,
	DropMenuDivider,
	DropMenuItem,
	HdataLogo,
} from '@sailadv/hdata-ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useBoatActions } from '@/entities/boat';
import { DOMAIN_ROUTES } from '@/entities/navigation';
import { useHasMultipleDomains, useUser } from '@/entities/user';
import { AppRoutes } from '@/shared/constants/app-routes.constant';
import { DOMAIN_OPTIONS } from '@/shared/constants/domain-options.constant';
import { USER_DOMAIN } from '@/shared/constants/user-domain.constant';
import { useCurrentDomain } from '@/shared/lib/hooks/use-current-domain.hook';

export const DomainSwitcher = () => {
	const { t } = useTranslation('login');
	const navigate = useNavigate();
	const hasMultipleDomains = useHasMultipleDomains();
	const { domains: userDomains } = useUser();
	const { resetBoatById } = useBoatActions();
	const currentDomain = useCurrentDomain();

	const handleNavigate = (path?: string) => () => {
		if (!path) return;

		navigate(path);
	};

	const handleSwitchDomain = (domain: USER_DOMAIN, path?: string) => () => {
		if (!path || domain === currentDomain) return;

		const { multiView } = DOMAIN_ROUTES[domain];

		resetBoatById();
		navigate(`${path}${multiView}`);
	};

	if (!hasMultipleDomains) {
		return (
			<ContextBarItem type="division" icon={<HdataLogo />}>
				{t(`selectDomain.${currentDomain}.title`)}
			</ContextBarItem>
		);
	}

	return (
		<ContextBarItem
			type="division"
			icon={<HdataLogo />}
			menu={
				<DropMenu
					aria-label={t('selectDomain.title')}
					selectionMode={DROP_MENU_SELECTION_MODE.SINGLE}
					selectedKeys={[currentDomain]}
				>
					{DOMAIN_OPTIONS.map(({ domain, path }) => (
						<DropMenuItem
							key={domain}
							id={domain}
							onAction={handleSwitchDomain(domain, path)}
							disabled={!path || !userDomains.includes(domain)}
							trailing={!path && <Badge tone="neutral">{t('selectDomain.comingSoon')}</Badge>}
						>
							{t(`selectDomain.${domain}.title`)}
						</DropMenuItem>
					))}
					<DropMenuDivider />
					<DropMenuItem trailing={<ArrowRightIcon size="sm" />} onAction={handleNavigate(AppRoutes.DomainSelection)}>
						{t('selectDomain.allDivisions')}
					</DropMenuItem>
				</DropMenu>
			}
		>
			{t(`selectDomain.${currentDomain}.title`)}
		</ContextBarItem>
	);
};
